'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdRoomService = function MdRoomService(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm23 13c6.5 1.3 11.5 6.8 12 13.6h-30c0.5-6.8 5.5-12.3 12-13.6-0.2-0.4-0.4-0.9-0.4-1.4 0-1.8 1.6-3.2 3.4-3.2s3.4 1.4 3.4 3.2c0 0.5-0.2 1-0.4 1.4z m-19.6 15.4h33.2v3.2h-33.2v-3.2z' })
        )
    );
};

exports.default = MdRoomService;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/room-service.js
// module id = 1856
// module chunks = 168707334958949